(() => {
  if (window.__vcCartSetGroupsBound) return;
  window.__vcCartSetGroupsBound = true;

  const rootSelector = '[data-vc-cart-set-groups]';

  function getSnapRows(root, setId) {
    return Array.from(root.querySelectorAll('tr[data-snap-of]')).filter((row) => row.dataset.snapOf === setId);
  }

  function updateSetTotal(collarRow) {
    const formattedTotal = collarRow.dataset.setTotalFormatted;
    if (formattedTotal) {
      collarRow.querySelectorAll('.price').forEach((element) => {
        element.textContent = formattedTotal;
      });
      return;
    }

    const setTotal = Number.parseInt(collarRow.dataset.setTotal || '0', 10);
    if (!Number.isFinite(setTotal) || setTotal <= 0) return;

    const fallbackTotal = `$${(setTotal / 100).toFixed(2)}`;
    collarRow.querySelectorAll('.price').forEach((element) => {
      element.textContent = fallbackTotal;
    });
  }

  function groupSets(root) {
    root.querySelectorAll('tr[data-collar-set]').forEach((collarRow) => {
      const setId = collarRow.dataset.collarSet;
      if (!setId) return;

      getSnapRows(root, setId).forEach((snapRow) => {
        snapRow.hidden = true;
      });

      updateSetTotal(collarRow);
    });
  }

  function scheduleGrouping(root) {
    if (root.dataset.vcGroupingScheduled === 'true') return;
    root.dataset.vcGroupingScheduled = 'true';

    requestAnimationFrame(() => {
      delete root.dataset.vcGroupingScheduled;
      groupSets(root);
    });
  }

  function initialiseRoot(root) {
    if (root.dataset.vcCartSetGroupsReady === 'true') {
      scheduleGrouping(root);
      return;
    }

    root.dataset.vcCartSetGroupsReady = 'true';
    groupSets(root);

    const observer = new MutationObserver(() => scheduleGrouping(root));
    observer.observe(root, { childList: true, subtree: true });
  }

  function initialiseRoots() {
    document.querySelectorAll(rootSelector).forEach(initialiseRoot);
  }

  function hasAddedCartSetRoot(mutations) {
    return mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some((node) => {
        if (!(node instanceof Element)) return false;
        return node.matches(rootSelector) || node.querySelector(rootSelector) !== null;
      })
    );
  }

  function restoreRemoveControl(control) {
    if (control instanceof HTMLButtonElement) control.disabled = false;
    control.removeAttribute('aria-disabled');
    control.style.pointerEvents = '';
    control.style.opacity = '';
  }

  function cartUpdateAjaxUrl() {
    const route = window.routes?.cart_update_url || '/cart/update';
    return route.endsWith('.js') ? route : `${route}.js`;
  }

  function removeSet(control, collarRow, root) {
    const setId = collarRow.dataset.collarSet;
    const lineKeys = [collarRow.dataset.collarKey]
      .concat(getSnapRows(root, setId).map((row) => row.dataset.snapKey))
      .filter(Boolean);
    if (!lineKeys.length) return;

    const updates = Object.fromEntries(lineKeys.map((lineKey) => [lineKey, 0]));
    if (control instanceof HTMLButtonElement) control.disabled = true;
    control.setAttribute('aria-disabled', 'true');
    control.style.pointerEvents = 'none';
    control.style.opacity = '0.5';

    fetch(cartUpdateAjaxUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        if (!response.ok) throw new Error(`update ${response.status}`);
        return response.json();
      })
      .then((cart) => {
        if (!cart || !Array.isArray(cart.items)) throw new Error('invalid cart response');
        window.location.reload();
      })
      .catch((error) => {
        console.error('VC remove set error:', error);
        restoreRemoveControl(control);
        window.alert('Could not remove the set. Please try again in a moment.');
      });
  }

  document.addEventListener(
    'click',
    (event) => {
      const control = event.target.closest('cart-remove-button button, cart-remove-button a');
      const collarRow = control?.closest('tr[data-collar-set]');
      const root = collarRow?.closest(rootSelector);
      if (!control || !collarRow || !root) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      removeSet(control, collarRow, root);
    },
    true
  );

  const start = () => {
    initialiseRoots();
    const pageObserver = new MutationObserver((mutations) => {
      if (hasAddedCartSetRoot(mutations)) initialiseRoots();
    });
    pageObserver.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
